"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantIndexedCollection = exports.TenantIndexedMappingCollection = exports.MappingCollection = exports.Collection = void 0;
/**
 * A collection in Firestore storing entities of type T
 */
class Collection {
    /**
     * @param collectionName Name of the collection in Firestore
     * @param eventPrefix Prefix for events. E.g. prefix = 'child', events will be 'child-update', etc.
     * @param docIdIsTenantName Whether the document id's are the tenant name, e.g. doc(collection/example): example is
     *        the name of the tenant
     */
    constructor(collectionName, eventPrefix, docIdIsTenantName = false) {
        this.collectionName = collectionName;
        this.eventPrefix = eventPrefix;
        this.docIdIsTenantName = docIdIsTenantName;
    }
}
exports.Collection = Collection;
/**
 * A collection that maps plain objects received from Firestore using a mapper to rich object
 */
class MappingCollection extends Collection {
    constructor(collectionName, eventPrefix, mapper, docIdIsTenantName = false) {
        super(collectionName, eventPrefix, docIdIsTenantName);
        this.mapper = mapper;
    }
}
exports.MappingCollection = MappingCollection;
/**
 * A collection that is indexed by tenant (every document contains a tenant field - e.g. { name: ..., tenant: ..., ... }
 * and mapping the plain objects it receives from the database to rich objects
 *
 * @tparam IT Interface type representing how the type is saved in the database
 * @tparam T Type of the lifted object
 */
class TenantIndexedMappingCollection extends Collection {
    constructor(collectionName, eventPrefix, mapper, docIdIsTenantName = false) {
        super(collectionName, eventPrefix, docIdIsTenantName);
        this.mapper = mapper;
    }
}
exports.TenantIndexedMappingCollection = TenantIndexedMappingCollection;
/**
 * A collection that is indexed by tenant (every document contains a tenant field - e.g. { name: ..., tenant: ..., ... }
 *
 * @tparam T Type of the lifted object. May not contain "tenant" field - will be dropped. Likewise, an "id" field will be
 *         added automatically when getting data, but will be stripped before persisting.
 */
class TenantIndexedCollection extends TenantIndexedMappingCollection {
    constructor(collectionName, eventPrefix, docIdIsTenantName = false) {
        const mapper = {
            lift(id, obj) {
                const { tenant } = obj, res = __rest(obj, ["tenant"]);
                return Object.assign({ id }, res);
            },
            unlift(obj) {
                const { id } = obj, res = __rest(obj, ["id"]);
                return res;
            },
        };
        super(collectionName, eventPrefix, mapper, docIdIsTenantName);
    }
}
exports.TenantIndexedCollection = TenantIndexedCollection;
//# sourceMappingURL=collection.js.map